import config from "../../config";
import React from "react";
import Button from "react-bootstrap/Button";
import { getCookie, isSearchUrl } from "../common/utils";
import _ from "underscore";
import moment from "moment";
import { ModelProductList } from "../common/ModelProductList";

// const newArrivalsCollectionScope = [17987005, 33120483, 66674688066];
const collectionScope = window.collectionScope || 0;

export const getParamsString = (forceAdditionalParamObj, forceProductNrLimit = 48, searchParams) => {
  const basicParamsObject = {};
  const queryParamsObject = {};
  const groupByRefinements = [];
  let paramsString = '';

  //we build the query params object that we find in URL
  searchParams.forEach((queryValue, queryName) => {
    if (queryName !== '_') {
      groupByRefinements.push({
        "type": "Value",
        "navigationName": `attributes.${queryName}`,
        "value": queryValue,
        "displayName": queryValue,
        "or": "true"
      })
    }

    queryParamsObject[queryValue] = queryName;
  });

  //we iterate through query params obj to start building the url
  let applyDefaultSort = true;
  for (let queryValue in queryParamsObject) {
    const emptyArray = queryParamsObject[queryValue].includes('pf_') ? '%5B%5D=' : '=';
    paramsString = paramsString + queryParamsObject[queryValue] + emptyArray + encodeURIComponent(queryValue) + '&';
    if (queryParamsObject[queryValue] === 'sort') {
      applyDefaultSort = false;
    }
  }

  //here we config standard query params to boost to params object
  basicParamsObject.shop = config.bc_shop;
  basicParamsObject.currency = 'usd';
  basicParamsObject.limit = forceProductNrLimit;
  basicParamsObject.collection_scope = collectionScope;
  basicParamsObject.product_available = 'false';
  basicParamsObject.build_filter_tree = 'true';
  basicParamsObject.sort_first = 'available';
  basicParamsObject.check_cache = 'false';
  if ((window.location.pathname.includes('new-arrivals') || window.location.pathname.includes('monthly-edit')) && applyDefaultSort) basicParamsObject.sort = 'created-descending';
  if (forceAdditionalParamObj) {
    const forceAdditionalParamKey = Object.keys(forceAdditionalParamObj)[0];
    basicParamsObject[forceAdditionalParamKey] = forceAdditionalParamObj[forceAdditionalParamKey];
  }

  //we iterate through basic query params obj build the url
  for (let key in basicParamsObject) {
    paramsString = paramsString + key + '=' + basicParamsObject[key]+ '&';
  }
  paramsString = paramsString.substring(0, paramsString.length - 1);
  if (!paramsString.includes('page=')) {
    paramsString += '&page=1';
  }
  return { paramsString, groupByRefinements };
}

export const memoizedGetParamsString = _.memoize((arg1, arg2, arg3) => {
  const cacheKey = `${arg1}-${arg2}-${arg3}`;
  return getParamsString(arg1, arg2, arg3);
}, (arg1, arg2, arg3) => `${arg1}-${arg2}-${arg3}`);

export const updateFilters = (filters, selectedCountry, init, user_profile) => {
  const params = new URLSearchParams(window.location.search);
  let userRank = 0;
  if (user_profile) {
    userRank = init.rewards_tiers[user_profile.tier.tier_key].rank;
  }
  const maxCount = {};
  const appliedFilters = [];
  const filtersWithOneValue = {};
  const updatedFilters = filters.map(filterBlock => {
    const getParamsByFilterBlockId = params.getAll(filterBlock.filterOptionId);
    const filterBlockRule = init.plp_filter_rules[filterBlock.filterOptionId];
    //we save filters that have exactly 1 value displayed
    if (filterBlock.values.length === 1) filtersWithOneValue[filterBlock.filterOptionId] = true;
    //we map the values of the filter block so that we can show checkbox check/uncheck status
    filterBlock.values?.map(value => {
      value.name = formatValueKey(filterBlock.prefix, value.key);

      //we check if we have a custom name ex: wholesale15 becomes Wholesale 15% Off
      if (customFilterOptionNames[value.key]) {
        value.name = customFilterOptionNames[value.key];
      }
      //we filter here first look + general view to not appear as tags
      if (getParamsByFilterBlockId.includes(value.key) && filterBlock.filterOptionId !== 'pf_t_first_look_hidden' && filterBlock.filterOptionId !=='pf_t_extra_tags_hidden') {
        value.optionSelected = true;
      } else {
        value.optionSelected = false;
      }
      return value
    })
    //we check if the url has this query param name and we filter a few of them
    if (params.has(filterBlock.filterOptionId) && filterBlock.filterOptionId !== 'pf_t_first_look_hidden' && filterBlock.filterOptionId !=='pf_t_extra_tags_hidden' && filterBlock.filterOptionId !== 'pf_st_availability_hidden') {
      //we define the filter tags applied that will appear
      getParamsByFilterBlockId.forEach(appliedQueryParamValue => {
        //we also check if the filter blocks are pf_t_meta_model_hidden or pf_t_meta_style_hidden in order to replace dashes with spaces in the label
        const name = (filterBlock.filterOptionId === "pf_t_model" || filterBlock.filterOptionId === "pf_t_style") ? getAppliedFilterName(filterBlock, appliedQueryParamValue).replace(/-/g, " ") : getAppliedFilterName(filterBlock, appliedQueryParamValue);
        const appliedQueryParamObject = {
          name: name,
          key: appliedQueryParamValue,
          optionSelected: true,
          filterOptionId:  filterBlock.filterOptionId,
          filterLabel: filterBlock.label,
          remove: {...filterBlockRule.remove,}
        }
        appliedFilters.push(appliedQueryParamObject);
      })
    }

    //if the filter has the remember_max_count true then we need to save its highest product count value
    if (filterBlockRule.remember_max_count) {
      maxCount[filterBlock.filterOptionId] = filterBlock.values.length ? filterBlock.values.sort((a, b) => b.doc_count - a.doc_count)[0].key : '';
    }
    if (filterBlockRule.hidden) {
      filterBlock.hidden = true;
    } else if (filterBlockRule.show_for_user) {
      //this is for the special filters that only appear in certain days - vip preview, sale, wholesale
      if (filterBlockRule.show_for_user.if_any) {
        //only 1 of the conditions needs to be met
       if (filterBlockRule.show_for_user.is_b2b) {
         if (getCookie('is_b2b')) {
           filterBlock.hidden = false;
         } else if (userRank >= filterBlockRule.show_for_user.min_tier) {
           filterBlock.hidden = false;
         } else {
           filterBlock.hidden = true;
         }
       } else if (userRank >= filterBlockRule.show_for_user.min_tier) {
         filterBlock.hidden = false;
       } else {
         filterBlock.hidden = true;
       }
      } else {
        //we need all conditions to be met
        if (userRank >= filterBlockRule.show_for_user.min_tier) {
          if (filterBlockRule.show_for_user.is_b2b) {
            filterBlock.hidden = !getCookie('is_b2b');
          } else {
            filterBlock.hidden = false;
          }
        } else {
          filterBlock.hidden = true;
        }
      }
    } else if (filterBlockRule.show_by_item_count) {
      if (maxCount[filterBlockRule.show_by_item_count.key] === filterBlockRule.show_by_item_count.value) {
        //ex: we only show apparel type if Apparel is the highest item count from category filter so we check that
        //against previously saved remember_max_count
        const getParamsByFilterBlockRule = params.getAll(filterBlockRule.show_by_item_count.key);
        if (getParamsByFilterBlockRule.length) {
          //here we check if other option from the same filter has been selected to hide the other one
          if (getParamsByFilterBlockRule.includes(filterBlockRule.show_by_item_count.value)) {
            filterBlock.hidden = false;
          } else {
            filterBlock.hidden = true;
          }
        } else {
          filterBlock.hidden = false;
        }
      } else {
        //the filter has the show by item count, but it's not the highest item count from the filter required
        //so we need to check the conditions are met
        let conditionsMet = 0;
        filterBlockRule.show_if_selected.forEach(paramProps => {
          const paramsFound = params.getAll(paramProps.key);
          if (paramProps.type === 'value') {
            if (paramsFound.includes(paramProps.value)) {
              conditionsMet += 1;
            }
          } else if (paramProps.type === 'count') {
            if (paramsFound.length === paramProps.value) conditionsMet +=1;
          }
        })
        filterBlock.hidden = filterBlockRule.show_if_selected.length !== conditionsMet;
      }
    } else if (filterBlockRule.show_if_any.length) {
      //only 1 of the rules needs to be met in order to show the filter ex: we show gender if either apparel/shoes
      //is selected
      const conditionMet = filterBlockRule.show_if_any.some(paramProps => {
        const paramsFound = params.getAll(paramProps.key);
        return paramsFound.includes(paramProps.value) || maxCount[paramProps.key] === paramProps.value;
      })
      filterBlock.hidden = !conditionMet;
    } else {
      //we need to meet all conditions in order to display the filter
      let conditionsMet = 0;
      filterBlockRule.show_if_selected.forEach(paramProps => {
        const paramsFound = params.getAll(paramProps.key);
        if (paramProps.type === 'value') {
          if (paramsFound.includes(paramProps.value)) {
            conditionsMet += 1;
          }
        } else if (paramProps.type === 'count') {
          if (paramsFound.length === paramProps.value) {
            conditionsMet +=1;
          } else if (filtersWithOneValue[paramProps.key]) {
            conditionsMet +=1;
          }
        }
      })
      filterBlock.hidden = filterBlockRule.show_if_selected.length !== conditionsMet;
    }

    if (filterBlock.filterOptionId === 'pf_t_price' && selectedCountry?.currency.isoCode !== 'USD') {
      filterBlock.hidden = true;
    }

    return filterBlock;
  })

  //we push to applied filers the query string as well
  if (isSearchUrl()) {
    const urlParams = new URLSearchParams(window.location.search);
    const q = urlParams.get('q');
    if (q) {
      appliedFilters.push({key: 'searchString', name: q})
    }
  }

  return {appliedFilters, updatedFilters}
}

export const groupByUpdateFilters = (filters, selectedCountry, init, user_profile) => {
  const params = new URLSearchParams(window.location.search);
  let userRank = 0;
  if (user_profile) {
    userRank = init.rewards_tiers[user_profile.tier.tier_key].rank;
  }
  const maxCount = {};
  const groupByAppliedFilters = [];
  const filtersWithOneValue = {};
  const groupByUpdatedFilters = filters.map(filterBlock => {
    filterBlock.filterOptionId = filterBlock.name.replace('attributes.', '');
    filterBlock.prefix = filterBlock.metadata ? filterBlock.metadata[0].value : null;
    filterBlock.label = filterBlock.displayName;
    filterBlock.manualValues = [];
    if (['pf_v_designers', 'pf_t_material'].includes(filterBlock.filterOptionId)) {
      filterBlock.showSearchBoxFilterMobile = true;
      filterBlock.showSearchBoxFilterPC = true;
    }

    if (['pf_t_watch_case_size', 'pf_t_stores', 'pf_t_material', 'pf_t_collections', 'pf_c_collections_hidden'].includes(filterBlock.filterOptionId)) {
      filterBlock.isCollapsePC = true;
    }
    const getParamsByFilterBlockId = params.getAll(filterBlock.filterOptionId);
    const filterBlockRule = init.plp_filter_rules[filterBlock.filterOptionId];
    if (!filterBlockRule) return filterBlock;
    //we save filters that have exactly 1 value displayed
    if (filterBlock.refinements.length === 1) filtersWithOneValue[filterBlock.filterOptionId] = true;
    //we map the values of the filter block so that we can show checkbox check/uncheck status
    filterBlock.refinements.map(value => {
      value.key = value.value;
      value.doc_count = value.count;
      value.name = formatValueKey(filterBlock.prefix, value.key);
      filterBlock.manualValues.push(value.value);
      //we check if we have a custom name ex: wholesale15 becomes Wholesale 15% Off
      if (customFilterOptionNames[value.key]) {
        value.name = customFilterOptionNames[value.key];
      }
      //we filter here first look + general view to not appear as tags
      if (getParamsByFilterBlockId.includes(value.key) && filterBlock.filterOptionId !== 'pf_t_first_look_hidden' && filterBlock.filterOptionId !=='pf_t_extra_tags_hidden') {
        value.optionSelected = true;
      } else {
        value.optionSelected = false;
      }
      return value
    })

    //we check if the url has this query param name and we filter a few of them
    if (params.has(filterBlock.filterOptionId) && filterBlock.filterOptionId !== 'pf_t_first_look_hidden' && filterBlock.filterOptionId !=='pf_t_extra_tags_hidden' && filterBlock.filterOptionId !== 'pf_st_availability_hidden') {
      //we define the filter tags applied that will appear
      getParamsByFilterBlockId.forEach(appliedQueryParamValue => {
        //we also check if the filter blocks are pf_t_meta_model_hidden or pf_t_meta_style_hidden in order to replace dashes with spaces in the label
        const name = (filterBlock.filterOptionId === "pf_t_model" || filterBlock.filterOptionId === "pf_t_style") ? getAppliedFilterName(filterBlock, appliedQueryParamValue).replace(/-/g, " ") : getAppliedFilterName(filterBlock, appliedQueryParamValue);
        const appliedQueryParamObject = {
          name: name,
          key: appliedQueryParamValue,
          optionSelected: true,
          filterOptionId:  filterBlock.filterOptionId,
          filterLabel: filterBlock.label,
          remove: {...filterBlockRule.remove,}
        }
        groupByAppliedFilters.push(appliedQueryParamObject);
      })
    }

    //if the filter has the remember_max_count true then we need to save its highest product count value
    if (filterBlockRule.remember_max_count) {
      maxCount[filterBlock.filterOptionId] = filterBlock.refinements.length ? filterBlock.refinements.sort((a, b) => b.count - a.count)[0].value : '';
    }
    if (filterBlockRule.hidden) {
      filterBlock.hidden = true;
    } else if (filterBlockRule.show_for_user) {
      //this is for the special filters that only appear in certain days - vip preview, sale, wholesale
      if (filterBlockRule.show_for_user.if_any) {
        //only 1 of the conditions needs to be met
        if (filterBlockRule.show_for_user.is_b2b) {
          if (getCookie('is_b2b')) {
            filterBlock.hidden = false;
          } else if (userRank >= filterBlockRule.show_for_user.min_tier) {
            filterBlock.hidden = false;
          } else {
            filterBlock.hidden = true;
          }
        } else if (userRank >= filterBlockRule.show_for_user.min_tier) {
          filterBlock.hidden = false;
        } else {
          filterBlock.hidden = true;
        }
      } else {
        //we need all conditions to be met
        if (userRank >= filterBlockRule.show_for_user.min_tier) {
          if (filterBlockRule.show_for_user.is_b2b) {
            filterBlock.hidden = !getCookie('is_b2b');
          } else {
            filterBlock.hidden = false;
          }
        } else {
          filterBlock.hidden = true;
        }
      }
    } else if (filterBlockRule.show_by_item_count) {
      if (maxCount[filterBlockRule.show_by_item_count.key] === filterBlockRule.show_by_item_count.value) {
        //ex: we only show apparel type if Apparel is the highest item count from category filter so we check that
        //against previously saved remember_max_count
        const getParamsByFilterBlockRule = params.getAll(filterBlockRule.show_by_item_count.key);
        if (getParamsByFilterBlockRule.length) {
          //here we check if other option from the same filter has been selected to hide the other one
          if (getParamsByFilterBlockRule.includes(filterBlockRule.show_by_item_count.value)) {
            filterBlock.hidden = false;
          } else {
            filterBlock.hidden = true;
          }
        } else {
          filterBlock.hidden = false;
        }
      } else {
        //the filter has the show by item count, but it's not the highest item count from the filter required
        //so we need to check the conditions are met
        let conditionsMet = 0;
        filterBlockRule.show_if_selected.forEach(paramProps => {
          const paramsFound = params.getAll(paramProps.key);
          if (paramProps.type === 'value') {
            if (paramsFound.includes(paramProps.value)) {
              conditionsMet += 1;
            }
          } else if (paramProps.type === 'count') {
            if (paramsFound.length === paramProps.value) conditionsMet +=1;
          }
        })
        filterBlock.hidden = filterBlockRule.show_if_selected.length !== conditionsMet;
      }
    } else if (filterBlockRule.show_if_any.length) {
      //only 1 of the rules needs to be met in order to show the filter ex: we show gender if either apparel/shoes
      //is selected
      const conditionMet = filterBlockRule.show_if_any.some(paramProps => {
        const paramsFound = params.getAll(paramProps.key);
        return paramsFound.includes(paramProps.value) || maxCount[paramProps.key] === paramProps.value;
      })
      filterBlock.hidden = !conditionMet;
    } else {
      //we need to meet all conditions in order to display the filter
      let conditionsMet = 0;
      filterBlockRule.show_if_selected.forEach(paramProps => {
        const paramsFound = params.getAll(paramProps.key);
        if (paramProps.type === 'value') {
          if (paramsFound.includes(paramProps.value)) {
            conditionsMet += 1;
          }
        } else if (paramProps.type === 'count') {
          if (paramsFound.length === paramProps.value) {
            conditionsMet +=1;
          } else if (filtersWithOneValue[paramProps.key]) {
            conditionsMet +=1;
          }
        }
      })
      filterBlock.hidden = filterBlockRule.show_if_selected.length !== conditionsMet;
    }

    if (filterBlock.filterOptionId === 'pf_t_price' && selectedCountry?.currency.isoCode !== 'USD') {
      filterBlock.hidden = true;
    }

    filterBlock.values = filterBlock.refinements;

    return filterBlock;
  })

  //we push to applied filers the query string as well
  if (isSearchUrl()) {
    const urlParams = new URLSearchParams(window.location.search);
    const q = urlParams.get('q');
    if (q) {
      groupByAppliedFilters.push({key: 'searchString', name: q})
    }
  }

  groupByUpdatedFilters.push({
    filterOptionId: 'pf_c_collections_hidden',
    label: 'Collections Hidden',
    hidden: true,
    name: 'attributes.pf_c_collections_hidden',
    values: [
      {
        "handle": "clair-picks",
        "id": "280543035569",
        "label": "Clair Picks",
        "sort_order": "best-selling"
      },
      {
        "handle": "seasonal-edit",
        "id": "284521398449",
        "label": "The Winter Edit",
        "sort_order": "best-selling"
      },
      {
        "handle": "vintage",
        "id": "160312164422",
        "label": "Vintage",
        "sort_order": "best-selling"
      },
      {
        "handle": "mens-styles",
        "id": "154508197958",
        "label": "Men's Styles",
        "sort_order": "best-selling"
      }
    ]
  })

  return {groupByAppliedFilters, groupByUpdatedFilters}
}

export const getSortOptions = (selectedSort, handleSortButton) => {
  const sortOptions = [...config.plp_sort_options];
  if (isSearchUrl()) sortOptions.splice(2, 0, {
    title: "Relevance",
    value: "relevance",
  });
  return (
    sortOptions.map((sortOption) => {
        return (
          <Button
            data-value={sortOption.value}
            data-active={selectedSort.value === sortOption.value}
            className="plp__sort-option bc-sf-custom-sort"
            variant="clean"
            key={sortOption.value}
            onClick={() => handleSortButton(sortOption)}
          >
            {sortOption.title}
          </Button>
        );
      })
  )
}

export const getAvailabilityOptions = (selectedAvailability, handleAvailabilityButton) => {
  return (
      config.plp_availability_options.map((availabilityOption) => {
        return (
            <Button
                data-value={availabilityOption.value}
                data-active={selectedAvailability.value === availabilityOption.value}
                className="plp__sort-option bc-sf-custom-sort"
                variant="clean"
                key={availabilityOption.value}
                onClick={() => handleAvailabilityButton(availabilityOption)}
            >
              {availabilityOption.title}
            </Button>
        );
      })
  )
}

export const stripHiddenFilterBlocks = (filterTree) => {
  return filterTree.filter((filterBlockItem => {
    return !filterBlockItem.hidden && filterBlockItem.values?.length > 0
  }));
}

export const insertFirstLookProducts = (products, firstLookProducts, mobile_medium) => {
  let mergedProducts = [...products];
  if (firstLookProducts.length > 1) {
    mergedProducts.splice(1, 0, firstLookProducts[0]);
    mergedProducts.splice(mobile_medium ? 5 : 3, 0, firstLookProducts[1]);
  } else if (firstLookProducts.length > 0) {
    mergedProducts.splice(1, 0, firstLookProducts[0]);
  }
  return ModelProductList(mergedProducts);
}

export const formatValueKey = (filterPrefix, value) => {
  const formattedFilterPrefix = filterPrefix ? filterPrefix.replace(/\\/g, '') : '';
  return capitalizeString(value.replace(formattedFilterPrefix, ''))
}

const capitalizeString = (str) => {
  const words = str.split("-");
  const capitalizedWords = words.map(word =>
    word.charAt(0).toUpperCase() + word.slice(1)
  );
  return capitalizedWords.join(" ");
}

const customFilterOptionNames = {
  "bc-filter-extra-tags-First Look": "VIP Preview",
  "bc-filter-extra-tags-b2b-vip": "VIP",
  "bc-filter-extra-tags-high_percent_off_retail": "High % Off Retail",
  "bc-filter-extra-tags-investment_piece": "Investment Piece",
  "bc-filter-extra-tags-trending": "Trending",
  "whnew": "New",
  "whreduced": "Reduced",
  "whclearancea": "Clearance A",
  "whclearanceb": "Clearance B",
  "sitewideselect": "10% Off",
  "20%-39%": "20% to 39%",
  "40%-59%": "40% to 59%",
}

const getAppliedFilterName = (filterBlock, appliedQueryParamValue) => {
  //we have a custom name for wholesale and vip preview
  if (['pf_t_wholesale_discounts', 'pf_t_vip_preview'].includes(filterBlock.filterOptionId)) {
    return customFilterOptionNames[appliedQueryParamValue]
  } else if (filterBlock.filterOptionId === 'pf_t_sale') {
    return customFilterOptionNames['sitewideselect'];
  } else {
    return formatValueKey(filterBlock.prefix, appliedQueryParamValue)
  }
}

export const buildPlpTitleTags = (appliedFilters) => {
  let collectionTitle = window.collectionTitle;
  let titleName = '';
  let descriptionName = 'handbags';
  const shopName = ' - Rebag';
  const {dynamicTitle, dynamicDescription} = getDynamicMeta(appliedFilters);

  if (collectionTitle === 'All Bags') {
    collectionTitle = '';
    titleName = 'Handbags';
    descriptionName = 'handbags';
  } else if (collectionTitle === 'All Accessories') {
    collectionTitle = '';
    titleName = 'Accessories';
    descriptionName = 'accessories';
  } else if (collectionTitle === 'All Watches') {
    collectionTitle = '';
    titleName = 'Watches';
    descriptionName = 'watches';
  } else if (collectionTitle === 'All Jewelry') {
    collectionTitle = '';
    titleName = 'Jewelry';
    descriptionName = 'jewelry';
  } else if (collectionTitle === 'All Shoes') {
    collectionTitle = '';
    titleName = 'Shoes';
    descriptionName = 'shoes';
  } else if (collectionTitle === 'All Apparel') {
    collectionTitle = '';
    titleName = 'Apparel';
    descriptionName = 'apparel';
  }

  if (dynamicTitle) {
    meta.titleTag = dynamicTitle;
  } else {
    meta.titleTag = 'Shop Authentic, Pre-Owned ' + collectionTitle + titleName + shopName;
  }
  if (dynamicDescription) {
    meta.descriptionTag = dynamicDescription;
  } else {
    meta.descriptionTag = "Shop all " + descriptionName + "online at rebag.com. We offer pre-loved, authentic luxury " + descriptionName + "for sale now. Financing and returns available.";
  }

  return {titleTag: meta.titleTag, descriptionTag: meta.descriptionTag}
}

const getDynamicMeta = (appliedFilters) => {
  let collectionTitle = window.collectionTitle;
  let dynamic_title = '';
  let dynamic_description = '';
  let current_type_term_1 = "";
  let current_type_term_2 = "";
  let filters_limit;
  let filtersObj = {};
  let color = "";
  let color_text = "";
  let designer = "";
  let designer_text = "";
  let style = "";
  let style_text = "";
  let store = "";
  let store_text = "";

  if (collectionTitle === 'All Accessories') {
    current_type_term_1 = "Accessories";
    current_type_term_2 = "Accessories";
  } else if (collectionTitle === 'All Watches') {
    current_type_term_1 = "Watches";
    current_type_term_2 = "Watches";
  } else if (collectionTitle === 'All Jewelry') {
    current_type_term_1 = "Jewelry";
    current_type_term_2 = "Jewelry";
  } else if (collectionTitle === 'All Shoes'){
    current_type_term_1 = "Shoes";
    current_type_term_2 = "Shoes";
  } else if (collectionTitle === 'All Apparel'){
    current_type_term_1 = "Apparel";
    current_type_term_2 = "Apparel";
  } else {
    current_type_term_1 = "Handbags";
    current_type_term_2 = "Bags";
  }

  appliedFilters.forEach(appliedFilter => {
    if (appliedFilter.filterOptionId === 'pf_t_categories') {
      if (filtersObj["pf_t_categories"]) {
        filtersObj["pf_t_categories"].push(appliedFilter);
      } else {
        filtersObj["pf_t_categories"] = [appliedFilter]
      }
    } else if (appliedFilter.filterOptionId === 'pf_v_designers') {
      if (filtersObj["pf_v_designers"]) {
        filtersObj["pf_v_designers"].push(appliedFilter);
      } else {
        filtersObj["pf_v_designers"] = [appliedFilter]
      }
    } else if (appliedFilter.filterOptionId === 'pf_t_price') {
      if (filtersObj["pf_t_price"]) {
        filtersObj["pf_t_price"].push(appliedFilter);
      } else {
        filtersObj["pf_t_price"] = [appliedFilter]
      }
    } else if (appliedFilter.filterOptionId === 'pf_t_stores') {
      if (filtersObj["pf_t_stores"]) {
        filtersObj["pf_t_stores"].push(appliedFilter);
      } else {
        filtersObj["pf_t_stores"] = [appliedFilter]
      }
    } else if (appliedFilter.filterOptionId === 'pf_t_color') {
      if (filtersObj["pf_t_color"]) {
        filtersObj["pf_t_color"].push(appliedFilter);
      } else {
        filtersObj["pf_t_color"] = [appliedFilter]
      }
    } else {
      if (filtersObj[appliedFilter.filterOptionId]) {
        filtersObj[appliedFilter.filterOptionId].push(appliedFilter);
      } else {
        filtersObj[appliedFilter.filterOptionId] = [appliedFilter]
      }
    }
  })



  if (filtersObj["pf_t_categories"]) {
    filters_limit = 2;
  } else {
    filters_limit = 1;
  }

  ///only 1 filter type selected other than categories
  if (Object.keys(filtersObj).length === filters_limit) {
    let add_suffix = true;
    dynamic_title = "Shop Authentic, Pre-Owned ";
    if (filtersObj["pf_v_designers"] && filtersObj["pf_v_designers"].length === 1) {
      add_suffix = false;
      dynamic_title += filtersObj["pf_v_designers"][0].name + " " + current_type_term_1 + " - Rebag";
      if (filtersObj["pf_v_designers"][0].name === 'Louis Vuitton') {
        dynamic_title = "Shop " + filtersObj["pf_v_designers"][0].name + " " + current_type_term_1 + " Bags & Accessories | Used & Authentic | Rebag";
      }
    } else if (filtersObj["pf_t_stores"] && filtersObj["pf_t_stores"].length === 1) {
      dynamic_title += current_type_term_1 + " at " + filtersObj["pf_t_stores"][0].name;
    } else if (filtersObj["pf_t_price"] && filtersObj["pf_t_price"].length === 1) {
      dynamic_title = current_type_term_2 + " from " + filtersObj["pf_t_price"][0].name;
    } else {
      dynamic_title = "";
      const filterValues = filtersObj[Object.keys(filtersObj)[filters_limit - 1]];
      filterValues.forEach((filterValue, index) => {
        if (filterValues.length > 1) {
           if (index < filterValues.length - 1) {
             dynamic_title += filterValue.name + ",";
           } else {
             dynamic_title += filterValue.name + " ";
           }
        } else {
          dynamic_title += filterValue.name + " ";
        }
      })
      dynamic_title += current_type_term_1;
    }
    if (add_suffix) {
      dynamic_title += " - Rebag";
    }
  } else if (Object.keys(filtersObj).length > filters_limit) {
    if (filtersObj["pf_v_designers"] && filtersObj["pf_v_designers"].length <= 1) {
      designer = filtersObj["pf_v_designers"][0].name;
      designer_text = designer + " ";
    }
    if (filtersObj["pf_t_color"] && filtersObj["pf_t_color"].length <= 1) {
      color = filtersObj["pf_t_color"][0].name;
      color_text = color + " ";
    }
    if (filtersObj["pf_t_stores"] && filtersObj["pf_t_stores"].length <= 1) {
      store = filtersObj["pf_t_stores"][0].name;
      store_text = " at " + store;
    }
    if (designer || color || style || store) {
      dynamic_title = "Shop Authentic, Pre-Owned " + color_text + designer_text + style_text + (style_text ? "" : current_type_term_1) + store_text + " - Rebag";
    }
  }

  if (filtersObj["pf_v_designers"] && filtersObj["pf_v_designers"].length === 1) {
    dynamic_description = "Shop " + filtersObj["pf_v_designers"][0].name + " " + current_type_term_1 + " online at rebag.com. We offer pre-owned, authentic luxury " + current_type_term_1 + " for sale now. Financing and returns available.";
  } else if (filtersObj["pf_t_stores"] && filtersObj["pf_t_stores"].length <= 1) {
    dynamic_description = "Shop " + current_type_term_1 + " at our " + filtersObj["pf_t_stores"][0].name + " store. We offer pre-owned, authentic luxury " + current_type_term_1 + " for sale now. Financing and returns available.";
  }

  return {dynamicTitle: dynamic_title, dynamicDescription: dynamic_description}
}

export const  isSitewidePromoDateInRange = (init, user_profile) => {
  const now = moment();
  const {vip_sitewide_promo, sitewide_promo} = init;
  const vipSiteWideStart = moment(vip_sitewide_promo.start_date, "DD/MM/YYYY");
  const vipSiteWideEnd = moment(vip_sitewide_promo.end_date, "DD/MM/YYYY");
  const siteWideStart = moment(sitewide_promo.start_date, "DD/MM/YYYY");
  const siteWideEnd = moment(sitewide_promo.end_date, "DD/MM/YYYY");
  let isUserMinSilver = false;

  if (user_profile) {
    if (init.rewards_tiers[user_profile.tier.tier_key].rank >= 2) {
      isUserMinSilver = true;
    }
  }

  return {
    isVipSiteWide: now.isBetween(vipSiteWideStart, vipSiteWideEnd, null, "[]") && isUserMinSilver,
    isSiteWide: now.isBetween(siteWideStart, siteWideEnd, null, "[]"),
  };
}

export const sendPlpGroupBySearchEvent = (products, firstLookProducts, mobile_medium, appliedFilters, nonUsd) => {
  const mergedProducts = insertFirstLookProducts(products, firstLookProducts, mobile_medium);
  const searchId = getCookie('searchId');

  if (mergedProducts.length > 0) {
    const newUrl = new URL(window.location.href);
    const searchValue = newUrl.searchParams.get('q');
    const productUrls = [];
    const mappedFilters = [];
    mergedProducts.forEach(product => {
      productUrls.push({_u: product.id});
    })

    //we iterate applied filters and add them mapped to the array needed for group by
    appliedFilters.forEach(filter => {
      const existingMappedFilter = mappedFilters.filter(mappedFilter => mappedFilter.name === filter.filterOptionId)[0];
      if (existingMappedFilter) {
        if (!existingMappedFilter.refinements.filter(refinement => refinement.value === filter.key)[0])
          existingMappedFilter.refinements.push({
            "type": filter.filterOptionId,
            "value": filter.key
          })
      } else {
        mappedFilters.push(
        {
          "name": filter.filterOptionId,
          "displayName": filter.filterLabel,
          "refinements": [
            {
              "type": filter.filterOptionId,
              "value": filter.key,
            }
          ],
        })
      }
    })

    //now we compare mapped filters with applied filter to remove the ones needed
    mappedFilters.forEach((mappedFilter, index) => {
      if (appliedFilters.find(appliedFilter => appliedFilter.filterOptionId === mappedFilter.name)) {
        mappedFilter.refinements.forEach((refinement, index) => {
          if (!appliedFilters.find(appliedFilter => appliedFilter.key === refinement.value)) {
            mappedFilter.refinements.splice(index, 1);
          }
        })
      } else {
        mappedFilter.splice(index, 1);
      }
    })

    if (window.gbTracker) {
        window.gbTracker.sendAutoSearchEvent({
          "search": {
            "id": searchId,
            "origin": {
              "search": true,
              "recommendations": false,
              "dym": false,
              "sayt": false,
              "navigation": false,
            },
          },
          "experiments": [
            {
              "experimentId": "RebagGroupByTest",
              "experimentVariant": "GroupBy"
            }
          ]
        })
      window.dataLayer.push({
        'event': 'api_provider',
        'type': 'plp_products',
        'value': 'GroupBy',
        'non_USD': nonUsd,
      });
    }
  }
}

export const getBuildGroupByPayload = (groupByRefinements, forceAdditionalParamObj, forceProductNrLimit, user_profile) => {
  const sortRefinement = groupByRefinements.find(refinement => refinement.navigationName === 'attributes.sort');
  const searchRefinement = groupByRefinements.find(refinement => refinement.navigationName === 'attributes.q');
  const paginationRefinement = groupByRefinements.find(refinement => refinement.navigationName === 'attributes.page');
  const productInStockAvailability = groupByRefinements.find(refinement => refinement.navigationName === 'attributes.pf_st_availability_hidden');

  const payload = {
    collection: config.gb_collection,
    area: config.gb_area,
    skip: "0",
    query: "",
    refinements: groupByRefinements,
    sorts: [],
    preFilter: "attributes.publishedOnChannel:ANY(\"true\") AND NOT attributes.tags:ANY(\"pfs:hidden\")",
    pageCategories: [],
    pageSize: forceProductNrLimit || 48
  };

  //send page category for ai group by
  if (window.location.pathname.includes('/collections/')) {
    payload.pageCategories = [`${window.location.pathname.replace('/collections/', '')}`];
  }

  //we remove the product in stock availability from the query params and we add it to the payload
  if (productInStockAvailability || !searchRefinement) {
    payload.preFilter += " AND availability:ANY(\"IN_STOCK\")";
    payload.refinements = payload.refinements.filter(refinement => refinement.navigationName !== 'attributes.pf_st_availability_hidden');
  }

  //we remove the sort from the query params and we add it to the payload
  const groupBySort = getGroupBySortObject(sortRefinement);

  if (!_.isEmpty(groupBySort)) {
    payload.sorts.push(groupBySort);
  }
  payload.refinements = payload.refinements.filter(refinement => refinement.navigationName !== 'attributes.sort');

  //we remove the search from the query params and we add it to the payload
  if (searchRefinement) {
    payload.query = searchRefinement.value;
    payload.refinements = payload.refinements.filter(refinement => refinement.navigationName !== 'attributes.q');
  }

  //we remove pagination from the query params and we add it to the payload
  if (paginationRefinement) {
    payload.refinements = payload.refinements.filter(refinement => refinement.navigationName !== 'attributes.page');
    payload.skip = `${parseInt(paginationRefinement.value) > 1 ? (parseInt(paginationRefinement.value) - 1) * 48 : 0}`;
  }

  //we request either bc-filter-extra-tags-First Look or bc-filter-General View
  if (forceAdditionalParamObj) {
    const forceAdditionalParamKey = Object.keys(forceAdditionalParamObj)[0];
    payload.preFilter += ` AND attributes.${forceAdditionalParamKey.replace('[]', '')}:ANY("${forceAdditionalParamObj[forceAdditionalParamKey]}")`;
  }

  //we need to add the collection scope to the payload so pre filter products
  if (collectionScope > 0) {
    payload.preFilter += ` AND attributes.collectionIds:ANY("${collectionScope}")`;
  }

  if (user_profile && user_profile.shopify_id) {
    payload.loginId = user_profile.shopify_id;
  }

  //we check against the list of filters and we remove other unsupported query params and we add it to the payload
  payload.refinements = payload.refinements.filter(refinement => config.plpFilters[refinement.navigationName.replace('attributes.', '')]);

  return payload;
}

export const getGroupBySortObject = (sortRefinement) => {
  const sortObject = {
    "extra-sort1-descending": {
      "field":"attributes.favorites_count",
      "order":"Descending"
    },
    "created-descending": {
      "field":"attributes.createdAtUnix",
      "order":"Descending"
    },
    "price-descending": {
      "field":"price",
      "order":"Descending"
    },
    "price-ascending": {
      "field":"price",
      "order":"Ascending"
    },
    "extra-sort3-descending": {
      "field":"attributes.percent_of_retail",
      "order":"Descending"
    }
  };

  if (sortRefinement) {
    return sortObject[sortRefinement.value];
  } else if (window.location.pathname.includes('new-arrivals')) {
    return sortObject["created-descending"];
  } else {
    return {}
  }
}

export const getResponsiveSettings = () => {
  return [
    // desktop big:
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    },
    // desktop:
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    // tablet:
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    },
    // mobile:
    {
      breakpoint: 540,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
  ];
}

export const sortAppliedFilters = ((appliedFilters) => {
  // copy to avoid mutating props/state
  const arr = [...appliedFilters];
  const idx = arr.findIndex(f => f.key === 'searchString');
  if (idx > 0) {
    // remove the searchString filter
    const [searchFilter] = arr.splice(idx, 1);
    // put it at front
    arr.unshift(searchFilter);
  }
  return arr;
});